import { FactureVenteService } from '@domain/ventes/FactureVenteService';
import { FactureInputSchema, type FactureInput } from '@shared/validation/FactureSchema';
import type { Facture, FactureLigne } from '@shared/types/Facture';
import type { Ecriture } from '@shared/types/Ecriture';
import { uuid } from '@shared/utils/uuid';

export class ComptabiliserFactureUseCase {
  execute(
    tenant_id: string,
    input: unknown,
    numero: string,
    client_compte: string,
  ): { facture: Facture; ecritures: Ecriture[] } {
    const validated: FactureInput = FactureInputSchema.parse(input);
    const lignesInput: Omit<FactureLigne, 'montant_ht' | 'montant_tva' | 'montant_ttc'>[] =
      validated.lignes.map((l: FactureInput['lignes'][number]) => {
        const ligne: Omit<FactureLigne, 'montant_ht' | 'montant_tva' | 'montant_ttc'> = {
          description: l.description,
          quantite: l.quantite,
          prix_unitaire: l.prix_unitaire,
          taux_tva: l.taux_tva,
          compte_produit: l.compte_produit,
        };
        if (l.axe_cdc) ligne.axe_cdc = l.axe_cdc;
        return ligne;
      });
    const calcul = FactureVenteService.calculer(lignesInput);
    const facture: Facture = {
      id: uuid('fac'),
      tenant_id,
      numero,
      client_id: validated.client_id,
      type: 'standard',
      date: validated.date,
      date_echeance: validated.date_echeance,
      ...(validated.objet ? { objet: validated.objet } : {}),
      ...(validated.devise ? { devise: validated.devise } : {}),
      ...(validated.axe_cdc ? { axe_cdc: validated.axe_cdc } : {}),
      ...calcul,
      statut: 'emise',
      cree_le: new Date().toISOString(),
    };
    const ecritures = FactureVenteService.genererEcritures(facture, client_compte);
    return { facture, ecritures };
  }
}
